<div [ngClass]="{'tap-top': show}" (click)="tapToTop()">
  <div class="tap-top"><i class="fa fa-angle-double-up"></i></div>
</div>
